import { getStorageItem } from 'utils/storage';
import { COOKIE_CONSENT_KEY, CookieConsentType } from 'components/cookie-policy/CookiePolicy';

const GTM_ID = 'GTM-TJLNLCF9';
const GTM_SCRIPT_ID = 'gtm-script';

export const hasAnalyticsConsent = () => getStorageItem(COOKIE_CONSENT_KEY) === CookieConsentType.accepted;

export const pushPageView = (path: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pageview',
    pageType: path,
    pageTitle: document.title
  });
};

/** Loads Google Tag Manager. Call only after the visitor accepted cookies; safe to call repeatedly. */
export const loadGtm = () => {
  if (document.getElementById(GTM_SCRIPT_ID)) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
};
